import type { IconName } from '@kernel';

import type { ButtonColor } from '@shared/button';

interface TopbarAction {
  id: 'recentlyAccessed' | 'alerts' | 'calendar';
  label: string;
  iconName: IconName;
}

interface ProfileAction {
  id: 'profile' | 'chatSettings' | 'myNotifications' | 'signOut';
  label: string;
  iconName: IconName;
  color: Extract<ButtonColor, 'secondary' | 'danger'>;
  description?: string;
}

type ProfileActionGroup = readonly ProfileAction[];

export type ProfileActionId = ProfileAction['id'];

export const TOPBAR_ACTIONS: readonly TopbarAction[] = [
  { id: 'recentlyAccessed', label: 'top.recentlyAccessed', iconName: 'history' },
  { id: 'alerts', label: 'top.alerts', iconName: 'alerts' },
  { id: 'calendar', label: 'top.calendar', iconName: 'calendar' },
];

export const PROFILE_ACTION_GROUPS: readonly ProfileActionGroup[] = [
  [
    {
      id: 'profile',
      label: 'top.userProfile.profile',
      iconName: 'profile',
      color: 'secondary',
      description: 'top.userProfile.profileDesc',
    },
    {
      id: 'chatSettings',
      label: 'top.userProfile.chatSettings',
      iconName: 'chat',
      color: 'secondary',
      description: 'top.userProfile.chatSettingsDesc',
    },
    {
      id: 'myNotifications',
      label: 'top.userProfile.myNotifications',
      iconName: 'alerts',
      color: 'secondary',
      description: 'top.userProfile.myNotificationsDesc',
    },
  ],
  [
    {
      id: 'signOut',
      label: 'top.userProfile.signOut',
      iconName: 'sign-out',
      color: 'danger',
    },
  ],
];
